<template>
  <div class="atb-login-container">
    <el-form class="atb-form atb-login-form" ref="loginForm" :model="loginForm" :rules="rules"
     @keyup.enter.native="login" @submit.native.prevent> 
      <h1 class="atb-text-center atb-color-white">{{$t('login.LoginBtn')}}</h1>
      <el-form-item prop="LOGIN_NAME">
        <el-input v-model="loginForm.LOGIN_NAME" placeholder="请输入用户名" clearable>
          <i slot="prefix" class="el-input__icon el-icon-user"></i>
        </el-input>
      </el-form-item>
      <el-form-item prop="PASSWORD">
        <el-input type="password" v-model="loginForm.PASSWORD" placeholder="请输入密码" clearable>
          <i slot="prefix" class="el-input__icon el-icon-lock"></i>
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button class="atb-block-btn" type="primary" :loading="loginLoading" @click="login">登录</el-button>
        <div class="atb-color-white atb-text-remark">
          <div>可用自己创建的用户</div>
          <div>系统内置用户: admin , 123456</div></div>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loginLoading: false,
      loginForm: {},
      rules: {
        LOGIN_NAME: [
          { required: true, message: '请输入登录账号', trigger: 'blur' }
        ],
        PASSWORD: [
          { required: true, message: '请输入登录密码', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    // store 重置
    this.$store.commit('resetStore')
    // 登录信息重置
    this.$userInfo.clearLoginInfo()
  },
  methods: {
    login() {
      if(this.loginLoading) return false;
      this.loginLoading = true
      this.$refs.loginForm.validate(valid=>{
        if(valid){
          this.$ajax.post("http://192.168.34.245:3000" + this.$api.common.login,this.loginForm).then(res=>{
            this.$userInfo.saveLoginInfo(res.data)
            this.$router.replace({name: 'main'}).catch(()=>{})
            this.loginLoading = false
          }).catch(()=>{
            this.loginLoading = false
          })
        }else{
          this.loginLoading = false
        }
      })
    }
  }
}
</script>
<style>
.atb-login-container {
  width: 100%;
  height: 100%;
  background-color: #2d3a4b;
}
.atb-login-container .atb-login-form{
  position: absolute;
  left: 50%;
  top: 50%;
  width: 400px;
  transform: translate(-50%, -70%)
}
.atb-text-remark{
  line-height: 20px;
  margin-top: 5px;
}
</style>
